/* eslint-disable css-modules/no-unused-class */

import styles from './utility.module.css';

export const utilityClasses = {
  ...styles,
} as const;

/**
 * Theme classes
 */
export const themeClasses = {
  dark: 'theme-dark',
  light: 'theme-light',
};

export const utilityCSSVariables = {
  transition: `var(--motion-duration-300)`,
};

export const layeringCSSVariables = {
  zIndexNegative: 'var(--z-index-negative)',
  zIndexDefault: 'var(--z-index-default)',
  zIndexS1: 'var(--z-index-s1)',
  zIndexS2: 'var(--z-index-s2)',
  zIndexS3: 'var(--z-index-s3)',
  zIndexS4: 'var(--z-index-s4)',
  zIndexS5: 'var(--z-index-s5)',
  zIndexS6: 'var(--z-index-s6)',
  zIndexS7: 'var(--z-index-s7)',
  zIndexS8: 'var(--z-index-s8)',
  zIndexS9: 'var(--z-index-s9)',
  zIndexPreOverlay: 'var(--z-index-pre-overlay)',
  zIndexOverlay: 'var(--z-index-overlay)',
  zIndexGlobalIndicator: 'var(--z-index-global-indicator)',
  zIndexTooltip: 'var(--z-index-tooltip)',
  zIndexToast: 'var(--z-index-toast)',
};
